import DentistsMapTitle from './DentistsMapTitle';

export default DentistsMapTitle;
